
import { OrderCellStatus } from "components/Orders/Orders/Components/OrderCellStatus";

import { DisplayPrices, Order } from "../types";

const Title = ({ text }: { text: string }) => {
    return (
        <div className="text-sm font-medium text-base-foreground w-44 shrink-0">{text}</div>
    )
}

const Value = ({ value }: { value: string }) => {
    return (
        <div className="text-sm text-base-mutedForeground font-light">{value}</div>
    )
}

const DetailRow = ({ title, value }: { title: string; value: string }) => {
    return (
        <div className="flex items-center gap-8">
            <Title text={title} />
            <Value value={value} />
        </div>
    )
}

export const OrderDetails = ({ order, publisherId, displayPrices }: { order?: Order, publisherId: string | undefined, displayPrices: DisplayPrices | null }) => {
    if (!order || !displayPrices) return null;

    return (
        <div className="flex flex-col gap-8 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
            <div className="flex items-center gap-4">
                <h2 className="font-medium text-xl text-base-primary">Total Payment: {order.currencySymbol}{(displayPrices.amountNetTotal + displayPrices.taxTotal).toFixed(2)}</h2>
                <OrderCellStatus status={order.status} />
            </div>

            <div className="grid grid-cols-2 gap-y-5 w-[75%] pl-4">
                <DetailRow title="Date" value={new Date(order.createdAt).toLocaleString()} />
                <DetailRow title="Payment Method" value={order.paymentMethod?.primaryMethod || 'N/A'} />

                <DetailRow title="Country" value={order.playerGeo.countryCode2} />
                <DetailRow title="Tax Rate" value={`${order.taxRatePoints / 100}%`} />

                <DetailRow title="State" value={order.playerGeo.state} />
                <DetailRow title="Player ID" value={order.playerId} />

                <DetailRow title="Postal Code" value={order.playerGeo.zipCode} />
                <DetailRow title="Player Email" value={order.playerEmail || 'N/A'} />
                <DetailRow title="Order ID" value={order._id} />

                <DetailRow title="Offer Name" value={order.bundleName} />
                <DetailRow title="Publisher Transaction ID" value={order.publisherPurchaseId || 'N/A'} />

                <DetailRow title="Offer External ID" value={order.bundleSku} />
                <DetailRow title="Project" value={publisherId ?? ''} />

                <DetailRow title="Subtotal" value={`${order.currencySymbol}${displayPrices.amountNetTotal.toFixed(2)}`} />
                <DetailRow title="Receipt Number" value={order.receiptId || 'N/A'} />
            </div>
        </div>
    )
}   